export { default } from './label-value.component';
